import React from "react";
import { Link } from "react-router-dom";
import Container from "Components/Container/Container";

const Hero = ({ name, cat }) => {
  return (
    <section className="normal-section">
      <Container className="pb-12s pt-32 lg:pt-48">
        <h2 className="text-white text-6xl md:text-7xl lg:text-8xl bebas uppercase mt-2 tracking-[12px] ">
          what's new
        </h2>
        <div className="text-xl text-[#808080] flex flex-wrap items-center gap-x-2 ">
          <Link to="/" className="hover:underline">
            Home
          </Link>
          <span>|</span>
          <Link to={"/news"} className="capitalize hover:underline">
            news and events
          </Link>
          <span>|</span>
          <p className="capitalize">{cat}</p>
          <span>|</span>
          <p className="capitalize">{name}</p>
        </div>
      </Container>
    </section>
  );
};

export default Hero;
